import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ToastProvider } from './components/ui/Toast';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import Experiences from './components/Experiences';
import Offerings from './components/Offerings';
import Rates from './components/Rates';
import BookingForm from './components/BookingForm';
import Ecology from './components/Ecology';
import Gallery from './components/Gallery';
import Story from './components/Story';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Admin from './pages/Admin';
import GettingHere from './pages/GettingHere';
import './App.css';

function HashScroller() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 80);
    } else {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [hash, pathname]);
  return null;
}

function Home() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <TrustStrip />
        <Experiences />
        <Offerings />
        <Rates />
        <BookingForm />
        <Ecology />
        <Gallery />
        <Story />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <HashScroller />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/getting-here" element={<GettingHere />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}
